<script>
import IconSearch from "../../../assets/icons/ic-search.svg";
import IconFiltre from "../../../assets/icons/ic-filtre.svg";
import radio from "../../helper/form/radio.vue";
import icKa from "../../../assets/icons/ic-ka.svg";
import Tel from "../../../assets/icons/ic-telephone.svg";
import { getService } from "@/component/cdevs/allFunctions";
import serviceLists from "./serviceLists.vue";
import prev from "../../../assets/icons/prev.svg";
import next from "../../../assets/icons/next.svg";

export default {
  name: "AllCharteredAccountant",
  components: { serviceLists, radio },
  props: {
    isLoading: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      icons: { IconSearch, IconFiltre, icKa, Tel, prev, next },
      all_service: [],
      charge: false,
      empty: false,
      limit: 20,
      page: 1,
      totalPage: 1,
      totalItems: 0,
      search: "",
      timer: null,
    };
  },

  created() {
    this.getAllService(this.limit, this.page, this.search);
    this.charge = this.isLoading
  },

  methods: {
    cleanObject(obj) {
      return Object.fromEntries(
        Object.entries(obj).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );
    },

    /* Function to get all chartered accountant */
    async getAllService(limit, page, search) {
      this.charge = true;
      const data = {
        apiKey: process.env.VUE_APP_OLD_X_PRIVATE_KEY,
        limit: limit,
        page: page,
        search: search
      };
      
      await getService(data)
        .then((response) => {
          console.log('Response complète:', response);
          this.all_service = response.data;
          
          // Mise à jour des informations de pagination
          // Vérifier différentes structures possibles de réponse
          if (response.total) {
            this.totalItems = response.total;
            this.totalPage = Math.ceil(response.total / this.limit);
          } else if (response.meta && response.meta.total) {
            this.totalItems = response.meta.total;
            this.totalPage = response.meta.totalPages || Math.ceil(response.meta.total / this.limit);
          } else if (response.pagination) {
            this.totalItems = response.pagination.total || 0;
            this.totalPage = response.pagination.totalPages || Math.ceil(response.pagination.total / this.limit);
          } else if (response.last_page) {
            this.totalPage = response.last_page;
            this.totalItems = response.total || 0;
          } else if (response.count) {
            this.totalItems = response.count;
            this.totalPage = Math.ceil(response.count / this.limit);
          } else {
            // Si la réponse retourne toujours la limite d'items, il y a probablement d'autres pages
            if (this.all_service.length === this.limit) {
              this.totalPage = this.page + 1; // Au minimum une page de plus
            } else {
              this.totalPage = this.page; // Dernière page
            }
          }
          
          console.log('Total pages:', this.totalPage, 'Page actuelle:', this.page);
          
          this.charge = false;
        })
        .catch((error) => {
          console.log(error);
          this.charge = false;
          this.$toast.error("Une erreur est survenue");
        });
    },

    refresh() {
      this.getAllService(this.limit, this.page, this.search);
    },

    // Navigation vers la page précédente
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.getAllService(this.limit, this.page, this.search);
      }
    },

    // Navigation vers la page suivante
    nextPage() {
      if (this.page < this.totalPage) {
        this.page++;
        this.getAllService(this.limit, this.page, this.search);
      }
    },

    // Aller à une page spécifique (optionnel)
    goToPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPage) {
        this.page = pageNumber;
        this.getAllService(this.limit, this.page, this.search);
      }
    },
  },

  watch: {
    search(newValue) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        // Réinitialiser la page à 1 lors d'une nouvelle recherche
        this.page = 1;
        this.getAllService(this.limit, this.page, newValue);
      }, 300);
    },
  },
};
</script>

<template>
  <div class="">
    <div class="flex justify-start responsive-container">
      <div class="flex items-center justify-start gap-5">
        <div
          class="flex items-center justify-start border border-gray py-2 rounded-100"
        >
          <icon
            :data="icons.IconSearch"
            height="20"
            width="20"
            class="w-5 h-5 mx-4"
            original
          />
          <input
            v-model="search"
            type="text"
            class="text-c16 responsive-input rounded-100"
            placeholder="Rechercher"
          >
        </div>
      </div>
    </div>

    <div class="responsive-container">
      <div
        class="backg w-full flex items-center TextColor h-14 px-5 rounded-t-10 mt-5"
      >
        <div class="flex items-center gap-5 w-1/2">
          <radio />
          <div>Service</div>
        </div>
        <div class="w-1/2 flex justify-start">
          Description
        </div>
        <div class="w-1/4 flex justify-start">
          Email de redirection
        </div>
        <div class="w-1/6 flex justify-start" />
      </div>

      <div
        v-if="charge"
        class="flex justify-center mt-16"
      >
        <easy-spinner
          type="dots"
          size="70"
        />
      </div>

      <div
        class="text-center my-10"
        v-if="!charge && all_service.length === 0"
      >
        Aucun service pour le moment
      </div>

      <div class="w-full">
        <serviceLists
          v-for="(item, i) in all_service"
          :key="i"
          :one-service="item"
          @refresh="refresh"
        />
      </div>
    </div>
    
    <div
      class="flex mt-10 justify-end pb-10 pr-10"
      v-if="!charge && all_service.length > 0"
    >
      <div class="w-1/3 flex items-center justify-end">
        <div class="text-c16 font-c6">
          Page {{ page }} sur {{ totalPage }}
        </div>
        <icon
          :data="icons.prev"
          height="50"
          width="50"
          :class="['icone ml-4', { 'cursor-not-allowed opacity-50': page <= 1, 'cursor-pointer': page > 1 }]"
          original
          @click="prevPage"
        />
        <icon
          :data="icons.next"
          height="50"
          width="50"
          :class="['icone ml-4', { 'cursor-not-allowed opacity-50': page >= totalPage, 'cursor-pointer': page < totalPage }]"
          original
          @click="nextPage"
        />
      </div>
    </div>
  </div>
</template>

<style>
.backg {
  background-color: #eff5f9;
}
.TextColor {
  color: #6b6b75;
  font-size: 16px;
  line-height: 18px;
  font-weight: 400;
}
.BorderColor {
  border-bottom: 1px solid #e7eef8;
}
.listeStyle {
  font-weight: 400;
  font-size: 18px;
}
.Email {
  color: #6aa3f2;
}
.icone {
  transition: opacity 0.2s ease;
}
</style>